export { InputGroup3RadioButtonsText } from "./InputGroup3RadioButtonsText";
export type { InputGroup3RadioButtonsTextProps } from "./InputGroup3RadioButtonsText";
export { default } from "./InputGroup3RadioButtonsText";
